import Footer from "../common/Footer";
import Navbar from "../common/Navbar";
import ScrollTop from "./ScrollTop";
import PerformanceOptimizer from "../common/PerformanceOptimizer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AppLayout = ({ children }) => {
  ScrollTop();
  return (
    <>
      <PerformanceOptimizer />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <ToastContainer position="bottom-right" hideProgressBar />
    </>
  );
};

export default AppLayout;
